import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-oups',
    templateUrl: './oups.component.html',
    styleUrls: [
        './oups.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OupsComponent implements OnInit
{
    @Input() title: string = '';
    @Input() message: string = '';

    constructor() { }

    ngOnInit ()
    {
    }
}
